import Container from "@/components/shared/AppContainer";
import React from "react";

const AskForReview = ({ navigation, route }) => {
  return <Container></Container>;
};

export default AskForReview;
